import { Injectable } from '@angular/core';
import { LogToken, DeviceType, EventLog } from '../../models/logs.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { ResolverService } from '../resolver/resolver.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  baseUrl: string = environment.logBaseUrl;

  constructor(
    private httpClient: HttpClient,
    private localStorageService: LocalStorageService,
    private resolverService: ResolverService
  ) { }

  registerDevice(
    deviceId: string,
    model: string,
    osVersion: string
  ): Observable<LogToken> {
    const data = {
      device_id: deviceId,
      device_type: DeviceType.WEB_DEVICE,
      model,
      os_version: osVersion
    }
    return this.httpClient.post<LogToken>(`${this.baseUrl}/services/register/`, data);
  }

  createEventLog(
    eventType: number,
    // eventTypeText: string,
    // email: string,
    extraData?: Object
  ): Observable<EventLog> {
    const data = {
      event_type: eventType,
      // event_type_text: eventTypeText,
      user: this.resolverService.userInitInfo.profile.username,
      extra_data: extraData
    }
    const token = this.localStorageService.logToken;
    const headers = new HttpHeaders().set('token', token);
    return this.httpClient.post<EventLog>(`${this.baseUrl}/events/set_log/`, data, { headers });
  }
}
